import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { useCallbackObservable, useObservable } from 'react-use-observable';

import { DownloadOutlined } from '@ant-design/icons';
import { Button } from 'antd';

import { saveAs } from 'file-saver';
import { formatDate } from 'helpers/date';
import { tap } from 'rxjs/operators';
import PermissionHide from 'v2/components/Shared/PermissionHide';
import ordersService from 'v2/services/orders';

export const Export = () => {
  const [loading, setLoading] = useState<boolean>(false);

  const [totalItems] = useObservable(() => ordersService.getTotalItems(), []);

  const [exportReport] = useCallbackObservable(() => {
    setLoading(true);
    return ordersService.export().pipe(
      tap(orders => {
        try {
          const dateExport = formatDate(new Date(), 'dd-MM-yyyy');
          const fileExport = new Blob([orders as Blob], { type: 'text/csv; charset=utf-8' });
          saveAs(fileExport, `minhas-entregas-${dateExport}.csv`);
          setLoading(false);
        } catch (e) {
          toast.error(e);
        } finally {
          setLoading(false);
        }
      })
    );
  }, []);

  return (
    <div>
      <PermissionHide action='myeduzz:minhas-entregas:exportar'>
        <Button
          className='px-4 text-[#37474F] outline-hidden'
          disabled={!totalItems || loading}
          onClick={exportReport}
          type='text'
          loading={loading}
          icon={<DownloadOutlined />}
        >
          {!loading ? 'Exportar' : 'Exportando...'}
        </Button>
      </PermissionHide>
    </div>
  );
};
